import { useIntl } from "react-intl";
import { Link } from "react-router";
import type { TobisHomeTitle } from "@/lib/tobis";
import { isRealUpdateTimestamp } from "@/lib/tobis-freshness";
import { TobisTitleCover } from "./TobisTitleCard";

// Schmale Karte fuer die Tobis-Zeile der Startseite: Poster, Name, Zeitpunkt
// des letzten Quellenkontakts.
//
// Eigene Komponente und nicht TobisTitleCard: die haengt am vollen TobisTitle
// (Bewertung, Stimmen, Besucher, Labor-Badges) und beantwortet damit die Frage
// "taugt der Titel als Vergleichsfilm". Hier lautet die Frage nur "was ist
// gerade hereingekommen", und der Endpunkt liefert bewusst eine schmale
// Projektion - die volle Titelabfrage kostet ein Vielfaches (siehe
// homeSummary). Geteilt wird, was sich sinnvoll teilen laesst: das Cover mit
// seinem Platzhalter.
export function TobisRecentCard({ title, index }: { title: TobisHomeTitle; index: number }) {
  const intl = useIntl();
  const zeit = isRealUpdateTimestamp(title.updatedAt ?? undefined)
    ? intl.formatDate(new Date(title.updatedAt as string), {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : null;

  return (
    <Link
      to={`/tobis/titles/${title.id}`}
      className="group w-28 shrink-0 focus:outline-none @sm:w-32"
    >
      <div className="box relative aspect-[2/3] overflow-hidden rounded-md bg-surface transition group-hover:ring-accent/40 group-focus-visible:ring-2 group-focus-visible:ring-ink/30">
        <TobisTitleCover title={title} index={index} />
      </div>
      <div className="mt-1.5 line-clamp-2 text-[12px] leading-tight text-ink/80 transition group-hover:text-accent">
        {title.name}
      </div>
      <div className="text-[11px] text-ink/40">
        {[zeit, title.year === null ? null : String(title.year)].filter(Boolean).join(" · ")}
      </div>
    </Link>
  );
}
